// Unverified reads of SM-signed token payloads. Hints only (scheduling,
// routing, UX): the signature is never checked here; the server verifies.

// decodeTokenSegment parses one base64url JSON segment, or null when it is not
// a JSON object.
export function decodeTokenSegment(segment: string): Record<string, unknown> | null {
  if (!segment) {
    return null;
  }
  try {
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const parsed: unknown = JSON.parse(atob(padded));
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return null;
    }
    return parsed as Record<string, unknown>;
  } catch {
    return null;
  }
}

// decodeJwtPayload returns a three-part JWT's payload claims, or null.
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }
  return decodeTokenSegment(parts[1]);
}
